module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "head1"
  }, [_c('strong', [_c('a', {
    attrs: {
      "id": "page_xii"
    }
  }, [_vm._v("ACKNOWLEDGMENTS")])])]), _c('a', {
    attrs: {
      "id": "page_xii"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("We would like to thank our publisher, Morgan James Publishing, and especially Dave Sauer and David Hancock who, because of their patience and encouragement, insured that this story would be published. We would also like to thank Cortney Donelson of vocem for her patience, encouragement, and the fantastic editing work that she did for us.")]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("A huge thank you to those whose lives positively impacted Mark’s story, especially those whose unfailing belief in him helped him to develop the ministries that he’s led.")]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("We would also like to thank the organizations that saw and encouraged Mark’s vision, including Joni and Friends, Wheels for the World, and Hope Haven, International.")]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("And last, too numerous to mention, are the many men and women who gave generously and risked much to help Mark on this divinely appointed journey.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-eeda81b4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/07_Acknowledgments.vue
// module id = 78
// module chunks = 0